// extracted by mini-css-extract-plugin
module.exports = {"gsapdGroupA":"groupcA_gsapdGroupA__asfUa"};